import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "./pages/Landing";
import PricingPage from "./pages/PricingPage";
import ShowcasePage from "./pages/ShowcasePage";
import CommunityShowcasePage from "./pages/CommunityShowcasePage";
import Builder from "./pages/Builder";
import SharedBuildPage from "./pages/SharedBuildPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import AuthCallback from "./pages/AuthCallback";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ContactPage from "./pages/ContactPage";
import ReferralsPage from "./pages/ReferralsPage";
import SignInModal from "./components/SignInModal";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, captureReferralFromUrl, useAuth } from "./context/AuthContext";

// Detects "#session_id=..." in URL fragment (set by Emergent OAuth) and
// renders the AuthCallback view instead of the normal route tree.
function AppRouter() {
  const location = useLocation();
  const { signInOpen, closeSignIn } = useAuth();

  useEffect(() => {
    captureReferralFromUrl();
  }, [location.search]);

  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/showcase" element={<ShowcasePage />} />
        <Route path="/showcase/community" element={<CommunityShowcasePage />} />
        <Route path="/build" element={<Builder />} />
        <Route path="/share/:shareId" element={<SharedBuildPage />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/auth/reset" element={<ResetPasswordPage />} />
        <Route path="/auth/verify" element={<VerifyEmailPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/referrals" element={<ReferralsPage />} />
      </Routes>
      <SignInModal open={signInOpen} onOpenChange={(v) => (v ? null : closeSignIn())} />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
